module.exports = __webpack_public_path__ + "images/bg-img-start_db33bcebfa8307fbc6615c2599cecb1f.png";